/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ArticleInShop {
    article_id?: number
    quantity: number
}

export interface ShopState {
    articleItems: ArticleInShop[]
    adult: number
    child: number
}

const initialState: ShopState = {
    articleItems: [],
    adult: 0,
    child: 0,
}

const shopSlice = createSlice({
    name: 'shop',
    initialState,
    reducers: {
        manipulateShopItem(
            state,
            action: PayloadAction<{ article_id: number; increment: number }>
        ) {
            const { article_id, increment } = action.payload
            const index = state.articleItems.findIndex(
                (item) => item.article_id === article_id
            )
            if (index === -1) {
                if (increment > 0) {
                    state.articleItems.push({ article_id, quantity: increment })
                }
            } else {
                state.articleItems[index].quantity += increment
                if (state.articleItems[index].quantity <= 0) {
                    state.articleItems.splice(index, 1)
                }
            }
        },
        resetState: () => initialState,
    },
})

export const { manipulateShopItem, resetState } = shopSlice.actions
export default shopSlice.reducer
